module.exports = __webpack_public_path__ + "img/bold-reader.fcf5eaad.png";